/**
 * Common slice — global loading flag plus app-wide error/message banners.
 *
 * The addMatcher hooks make this automatic: ANY thunk's pending clears the
 * banners, fulfilled shows payload.message (if present) via AppMessage, and
 * rejected shows the error via AppError. Individual components rarely need
 * their own error handling because of this.
 */
import { createSlice } from "@reduxjs/toolkit";

const isActionWithPending = (action) => {
  return action.type.endsWith("/pending");
};

const isActionWithFulfilled = (action) => {
  return (
    action.type.endsWith("/fulfilled")
  );
};

const isActionWithFailed = (action) => {
  return action.type.endsWith("/rejected");
};

const commonSlice = createSlice({
  name: "common",
  initialState: {
    globalLoading: false,
    error: {},
    message: null,
  },
  reducers: {
    setGlobalLoading: (state, action) => {
      const globalLoading = action.payload;
      state.globalLoading = globalLoading;
    },
    setError: (state, action) => {
      const error = action.payload;
      state.error = error;
    },
    setMessage: (state, action) => {
      const message = action.payload;
      state.message = message;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isActionWithPending, (state) => {
      state.error = {};
      state.message = null;
    });
    builder.addMatcher(isActionWithFulfilled, (state, action) => {
      state.error = {};
      const message = action.payload.message;
      if (message) {
        state.message = message;
      }
    });
    builder.addMatcher(isActionWithFailed, (state, action) => {
      state.error = action.payload;
      state.message = null;
    });
  },
});

const { actions, reducer: commonReducer } = commonSlice;
export const { setGlobalLoading, setError, setMessage } = actions;

export default commonReducer;
